export default {
  open_standalone: 'Abierto',
  closed_standalone: 'Cerrado',

  open: 'Abierto',
  closed: 'Cerrado',
  opening: 'Abre',
  closing: 'Cierra',
  yes_we_are: 'Estamos',
  sorry_we_are: 'Fueron',
  twentyfourseven: 'Permanente',
  closing_tomorrow: 'Cierra mañana',
  opening_tomorrow: 'Abre mañana',
  at_x: 'a las %x%',
  closing_x: 'Cerrar a %x%',
  opening_x: 'Abre %x%',

  monday: 'lunes',
  tuesday: 'martes',
  wednesday: 'miércoles',
  thursday: 'jueves',
  friday: 'viernes',
  saturday: 'sábado',
  sunday: 'domingo',

  businessHours: 'horarios de apertura'
};



// WEBPACK FOOTER //
// ./src/commons/translations/es.js